import {
  NetfondsConsentContext,
  NetfondsConsentEvent,
} from "../netfondsConsentSM";

export const addAxiosErrorToContextAction = (
  context: NetfondsConsentContext,
  event: NetfondsConsentEvent
) => {
  if (event.type !== "SOMETHING_WRONG") return {};

  return {
    error: event.error?.response?.data,
  };
};
